import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'
import * as FilePond from 'filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import fr_fr from 'filepond/locale/fr-fr.js';

FilePond.setOptions(fr_fr);
FilePond.registerPlugin(FilePondPluginFileValidateType);

// eslint-disable-next-line no-undef
const object = vnObject


const pond = FilePond.create(document.querySelector('.filepond-cv'), {
  acceptedFileTypes: ['application/pdf'],
  fileValidateTypeLabelExpectedTypesMap: {
    'application/pdf': '.pdf',
  },
  fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const fileError = $('#js-filepond-error-container');
pond.on('addfile', (event) => {
  fileError.html('')
});

pond.on('removefile', (event) => {
  fileError.html(fileError.attr('data-error-message'))
});


$('.js-job-offer-apply').parsley()

$('.js-job-offer-apply').on('submit', function (e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()

  const $form = $(this)

  const formData = new FormData($(this)[0])
  formData.append('action', 'vn_job_apply')
  var pondFiles = pond.getFiles();
  formData.append('cv', pondFiles[0].file);

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    dataType: 'JSON',
    data: formData,
    processData: false,
    contentType: false,
    beforeSend: () => {
      $form.addClass('sending')
      Alert('warning', object.formWait, false)
    },
    success: (res) => {
      $form.removeClass('sending')

      if (res.success && res.data.redirect) {
        window.location = res.data.redirect
      }

      if (!res.success) {
        Alert(res.success, res.data.message)
      }
    },
  })
})
